import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportUsersCommunications_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportUsersCommunications extends Report<ReportUsersCommunications_Settings> {

    static reportName   : string = "Communication"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_USERS_COMMUNICATIONS
        super(data);

        this.icon         = "isvg-communication"
        this.name           = data.name || "Communication"
        this.description  = "Provides insights into communication patterns and engagement."

        this.settings     = new ReportUsersCommunications_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportUsersCommunications {
        return new ReportUsersCommunications(savedView.toReportConfig());
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportUsersCommunications_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectId = projectId
    }

    save(){
        console.log("Not implemented")
    }
}
